module.exports = __webpack_public_path__ + "img/schedule_page3.3b23324c.jpg";